export default "__VITE_ASSET__FCQt$1yA__"